<script lang="ts" module>
  import type { NavData } from '../../../types/navData';
  import type { CartStore } from '../../../stores/cart';

  export interface NavbarHeaderBottomProps {
    navData?: NavData;
  }
</script>

<script lang="ts">
  import { page } from '$app/state';
  import { PUBLIC_BRAND_NAME, PUBLIC_BRAND_SLUG } from '$env/static/public';

  import { getContext } from 'svelte';
  import { Check, ShoppingCart } from 'phosphor-svelte';

  import { float } from '@agapi/ui/panda/patterns';
  import { css } from '@agapi/ui/panda/css';
  import { Button } from '@agapi/ui/button';
  import { Badge } from '@agapi/ui/badge';
  import { Loader } from '@agapi/ui/loader';
  import { NavbarRow, NavbarGroup, NavbarBrand, NavbarMenuToggle, NavbarDrawerToggle } from '@agapi/ui/navbar';

  import Search from './navbar-search.svelte';
  import { rewriteUrl } from '../../../utils';
  import * as m from '$lib/parachute/messages';

  import Logo from '$lib/assets/logo.svg';

  const { navData }: NavbarHeaderBottomProps = $props();
  const cart = getContext<CartStore>('cart-store');
</script>

<NavbarRow css={{ position: 'relative', pb: 5, pt: 4 , sm: { pb: 0 }, md: { pb: 2, pt: 2 } }}>
  <NavbarGroup css={{  flex: 1 , md: { flex: 'unset' } }}>
    <!-- Menu Toggle -->
    <NavbarMenuToggle css={{ hideFrom: 'md' }} />

    <!-- Brand Logo -->
    <NavbarBrand href={rewriteUrl(page, '/')} css={{  display: 'flex', flex: 1, justifyContent: 'center', mr: "-6", sm: { flex: 'unset', mr: "unset" } }}>
      <img src={Logo} class={css({ maxWidth: "logo.navbar" })} alt={`${PUBLIC_BRAND_NAME} Logo`} />
    </NavbarBrand>

    <!-- Search -->
    <Search />
  </NavbarGroup>

  <!-- Usps -->
  <NavbarGroup label="Usps" css={{ flex: 1, justifyContent: 'flex-end', gap: 2, minWidth: 0, hideBelow: 'md' }}>
    {#each navData?.usp_checklist ?? [] as usp}
      <span class={css({ fontSize: 'sm', display: 'flex', alignItems: 'center', gap: '2', fontWeight: 'medium', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', p: 0, m: 0 })}>
        <Check weight="bold">
          <title>{m.iconCheck()}</title>
        </Check>
        {usp.label}
      </span>
    {/each}
  </NavbarGroup>

  <!-- Cart Indicator Button -->
  <NavbarGroup label="User Actions">
    <NavbarDrawerToggle openLabel="Öppna kundvagn ({cart.summary?.formatted.totalAmount}, {cart.items.length} {cart.items.length === 1 ? 'produkt' : 'produkter'})" closeLabel="Öppna kundvagn ({cart.summary?.formatted.totalAmount}, {cart.items.length} {cart.items.length === 1 ? 'produkt' : 'produkter'})">
      <Button as="span" variant={PUBLIC_BRAND_SLUG === 'happy-green' ? 'cta' : 'secondary'} css={{  px: '3', py: '3', fontSize: 'sm', lg: { px: '4', py: '3', fontSize: 'md' } }}>
        <ShoppingCart>
          <title>{m.iconShoppingCart()}</title>
        </ShoppingCart>
        {#if cart.loading}
          <span class={css({ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'absolute', top: 0, left: '11px', right: 0, bottom: 0 })}>
            <Loader size="sm" type="dots" />
          </span>
        {/if}

        <span style:opacity={cart.loading ? 0 : 1}>
          {cart.summary?.formatted.finalAmount}
        </span>
        <div class={float({ placement: 'top-start', offsetX: '2', offsetY: '2' })}>
          <Badge size="xs" colorVariant={PUBLIC_BRAND_SLUG === 'happy-green' ? 'primary.vibrant' : 'primary.tonal'}>{#if cart.loading}
            <Loader type="dots" size="xs" />
          {:else}
            {cart.items.reduce((acc, item) => acc + item.quantity, 0)}
          {/if}
          </Badge>
        </div>
      </Button>
    </NavbarDrawerToggle>
  </NavbarGroup>
</NavbarRow>
